import angular from 'angular';
import uiRouter from 'angular-ui-router';
import categoryComponent from './category.component';
import categoryFactory from './category.factory';

const categoryModule = angular
  .module('category', [uiRouter])
  .component('category', categoryComponent)
  .factory('Category', categoryFactory)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('category', {
      url: '/category',
      component: 'category',
    });
  }).name;

export default categoryModule;



// WEBPACK FOOTER //
// ./client/app/components/category/category.js